import MapComponent from "components/MapComponent/MapComponent";
import asset from "json/assets";
import MapWrapper from "layout/MapWrapper/MapWrapper";
import styles from "styles/component/NoItemFound.module.scss";
import CustomButton from 'ui/CustomButton/CustomButton';

export default function NoMatchFound() {
 
  return (
    <MapWrapper title={'DRIVING RANGE'}>
      <div className={styles.match_wrap_full}>
        <div className={styles.match_wrap}>
          <i className={styles.srch_icon}>
            <img src={asset.srchIcon} alt="" />
          </i>
          <p className={styles.blue_txt}>No Matches Found For: 12 7</p>
          <p className={styles.gray_txt}>Please refine your search request</p>
          <CustomButton>Cancel</CustomButton>
          {/* <Link to={"#"} className={styles.blue_btn}>
            Cancel
          </Link> */}
        </div>
      </div>
    </MapWrapper>
  );
}
